import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button';

export const AfriqGreyButton = styled(Button)({
    borderRadius: 100,
    color: '#ffffff',
    backgroundColor: '#7D7D57',
    fontFamily: "Josefin Sans",
    textTransform: "none",
    '&:hover': {
        backgroundColor: '#61614c'
    }
})

export const AfriqRedButton = styled(Button)({
    borderRadius: 100,
    color: '#ffffff',
    backgroundColor: '#890608',
    fontFamily: "Josefin Sans",
    textTransform: "none",
    '&:hover': {
        backgroundColor: '#5c1617'
    }
})

export const AfriqNoBorderButton = styled(Button)({
    border: 'none',
    color: '#7D7D57',
    backgroundColor: '#f7f7f7',
    fontFamily: "Josefin Sans",
    textTransform: "none",
    '&:hover': {
        color: '#666651'
    }
})

